import { Component, OnInit, Inject, Input } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-image-viewer-modal.',
  templateUrl: './imageViewerModal..component.html',
  styleUrls: ['./imageViewerModal.component.css']
})
export class ImageViewerModalComponent implements OnInit {

  constructor(protected ref: NbDialogRef<ImageViewerModalComponent>,
    private translate: TranslateService,
    public apiService: ApiService) { }

  @Input() image: string;
  rotateDeg: any = 0;
  zoom: any = 1;

  ngOnInit() {
  }


  close() {
    this.ref.close();
  }
  rotate() {
    this.rotateDeg = this.rotateDeg + 90
    const img = document.getElementById('viewableImage') as HTMLImageElement;
    img.style.transform = `rotate(${this.rotateDeg}deg)`
  }

  zoomIn(direction) {
    const delta = 100 * direction;
    const element = document.getElementById('viewableImage');
    const positionInfo = element.getBoundingClientRect();
    element.style.width = positionInfo.width + delta + 'px';
    element.style.height = positionInfo.height + delta + 'px';
  }
}
